import React from 'react';
import { DiaryEntry } from './DiaryEntry';
export function DiarySection() {
  return <section className="max-w-3xl mx-auto px-6 py-12" data-id="element-25">
      <DiaryEntry date="15. Dezember 2024" title="Das Problem" delay={0.1} content={<div className="space-y-6" data-id="element-27">
            <p data-id="element-28">
              Max frisst morgens sein Futter und danach beginnt das Würgen. Es
              zerreißt mir jedes Mal das Herz. Er steht im Garten und frisst
              ständig Gras, als gäbe es kein Morgen mehr. Er schläft schlecht,
              wälzt sich nachts unruhig hin und her und schmatzt laut.
            </p>
            <p data-id="element-29">
              Der Tierarzt findet nichts. "Das ist bei manchen Hunden einfach
              so, vielleicht ein empfindlicher Magen", heißt es. Ein zweiter
              Tierarzt verschreibt Säureblocker, die kurzfristig helfen, aber
              sobald wir sie absetzen, ist alles wieder beim Alten.
            </p>
            <p data-id="element-30">
              Ich bin verzweifelt. Es kann doch nicht normal sein, dass mein
              Hund nach jeder Mahlzeit leidet. Ich verbringe Nächte damit, Foren
              zu durchforsten, wechsle das Futter dreimal, koche Schonkost –
              nichts bringt dauerhaft Ruhe in seinen Bauch.
            </p>
          </div>} data-id="element-26" />

      <DiaryEntry date="28. Januar 2025" title="Der Wendepunkt" delay={0.2} content={<div className="space-y-6" data-id="element-32">
            <p data-id="element-33">
              Eine Hundemama aus meiner lokalen Facebook-Gruppe erwähnt
              beiläufig ein natürliches Futtertopping. Sie hatte mit ihrem
              Golden Retriever ähnliche Probleme und schwört auf eine Mischung
              mit Mariendistel, Topinambur und Präbiotika.
            </p>
            <p data-id="element-34">
              Ich bin ehrlich gesagt skeptisch. Nach all dem Geld, das ich beim
              Tierarzt und für Spezialfutter gelassen habe, soll ein einfaches
              Pulver die Lösung sein? Aber wenn man verzweifelt ist, greift man
              nach jedem Strohhalm.
            </p>
            <p data-id="element-35">
              Ich bestelle es. Was kann ich schon verlieren? Es ist 100%
              pflanzlich, also kann es zumindest nicht schaden. Als das Paket
              ankommt, mische ich am Abend den ersten Löffel unter sein Futter.
              Max schnuppert kurz und frisst dann alles restlos auf. Ein guter
              Anfang.
            </p>
          </div>} data-id="element-31" />

      <DiaryEntry date="25. Februar 2025" title="Die Veränderung" delay={0.3} content={<div className="space-y-6" data-id="element-37">
            <p data-id="element-38">
              Nach 10 Tagen bemerke ich die erste Veränderung: Max frisst Gras
              deutlich seltener. Er steht nach dem Fressen nicht mehr sofort
              auf, um in den Garten zu rennen.
            </p>
            <p data-id="element-39">
              Jetzt, nach 3 Wochen, wage ich es kaum laut auszusprechen: Kein
              nächtliches Würgen mehr. Nichts. Er schläft durch, eingerollt in
              seinem Körbchen, ohne Schmatzen, ohne Unruhe. Er frisst sein
              Futter wieder entspannt und freut sich sogar darauf.
            </p>
            <p data-id="element-40">
              Ich kann es wirklich kaum glauben. Ich habe meinen fröhlichen,
              unbeschwerten Hund zurück. Wenn ich gewusst hätte, dass die Lösung
              so einfach und natürlich sein kann, hätte ich uns beiden
              monatelangen Stress erspart.
            </p>
          </div>} data-id="element-36" />
    </section>;
}